import QueryString from 'qs';

import { EInteractEventTrackerAction } from '@/app/features/InteractEventTracker/enums/EInteractEventTracker';
import { sendInteractEvent } from './events';

export const goToExternal = (baseURL: string, path: string = '', queryParams?: any, newTab?: boolean): any => {
  const completeURL = `${baseURL}${path}?${queryParams ? `?${QueryString.stringify(queryParams)}` : ''}`;

  if (newTab) {
    return window.open(completeURL, '_blank', 'noopener');
  }

  return window.location.replace(completeURL);
};

export const goToSitePage = (page: string = '', queryParams?: any, newTab?: boolean): any => {
  return goToExternal(process.env.VUE_APP_SITE_URL as string, page, queryParams, newTab);
};

export const goToDashboard = (queryParams: string = ''): any => {
  sendInteractEvent({
    action: EInteractEventTrackerAction.CHK_CLICKED_RECOMMENDATION_LA,
    attributes: {
      recommended_content_url: process.env.VUE_APP_DASHBOARD_URL,
    },
  }).then(() => {
    setTimeout(() => {
      return goToExternal(process.env.VUE_APP_DASHBOARD_URL as string, '', queryParams);
    }, 1500);
  });
};

export const goToFAQPage = (): any => goToSitePage('faq');

export const redirectRootVisit = (): any => goToSitePage('assinaturas', {
  xpromo: 'XE-MI-ECOMM-X-X-X-REDIR-INDEX-X-X',
});

export const redirectAvailabilityErrorOr404 = (): any => goToSitePage('assinaturas', {
  xpromo: 'XE-MI-ECOMM-X-X-X-REDIR-NF-X-X',
  notfound: true,
});

export const redirectToPolicy = (): any => goToSitePage('politica-de-privacidade', {
  xpromo: 'XE-ME-GGL-IE-X-X-SH-X-X',
}, true);
